import React, {useMemo} from 'react'
import styles from './UIGamePlayerInfoSectionContent.module.scss'
import {CardEnum, CardStateUnordered, CardTypeEnum, MechanicCityImprovementsPlayerState} from '@colonist/game-states'
import {UIGameCityImprovementTracker} from '../../../../../common/UIGameCityImprovementTracker/UIGameCityImprovementTracker'
import {UIGameCardInventory} from '../../../../../common/UIGameCardInventory/UIGameCardInventory'
import {CardDataController} from '@colonist/game-card-types'
import {Tooltip, T} from '@colonist/ui'
import {CARD_STACK_SIZES_1} from '../CardStateUnorderedStackSize1'

export interface UIGamePlayerInfoSectionContentCKProps {
    progressCardState: CardStateUnordered
    cityImprovementState: MechanicCityImprovementsPlayerState
}

const PROGRESS_CARD_BACKS = [
    {backEnum: CardEnum.ProgressCardScienceBack, type: CardTypeEnum.ProgressScience},
    {backEnum: CardEnum.ProgressCardTradeBack, type: CardTypeEnum.ProgressTrade},
    {backEnum: CardEnum.ProgressCardPoliticsBack, type: CardTypeEnum.ProgressPolitics},
] as const

export const UIGamePlayerInfoSectionContentCK = ({
    progressCardState,
    cityImprovementState,
}: UIGamePlayerInfoSectionContentCKProps) => {
    const {cardState, cardsToDisable, cardsToHideBadge} = useMemo(() => {
        const resultCardState: CardStateUnordered = {}
        const resultCardsToDisable: CardStateUnordered = {}
        const resultCardsToHideBadge: CardEnum[] = []

        for(const {backEnum, type} of PROGRESS_CARD_BACKS) {
            const cardEnums = CardDataController.getCardEnumsOfTypes([type])
            let count = progressCardState[backEnum] ?? 0
            for(const cardEnum of cardEnums) {
                count += progressCardState[cardEnum] ?? 0
            }
            resultCardState[backEnum] = Math.max(count, 1)
            if(count === 0) {
                resultCardsToDisable[backEnum] = 1
                resultCardsToHideBadge.push(backEnum)
            }
        }

        return {cardState: resultCardState, cardsToDisable: resultCardsToDisable, cardsToHideBadge: resultCardsToHideBadge}
    }, [progressCardState])

    return (
        <div className={styles.container}>
            <div className={styles.cityImprovementTrackerContainer}>
                <Tooltip
                    content={<div>
                        <div><T id='strings:game.tips.cityImprovementButton.body.0'/></div>
                        <div><T id='strings:game.tips.cityImprovementButton.body.1'/></div>
                    </div>}
                    title={<T id='strings:game.tips.cityImprovementButton.title'/>}>
                    <UIGameCityImprovementTracker
                        className={styles.cityImprovementTracker}
                        cityImprovementState={cityImprovementState} />
                </Tooltip>
            </div>
            <UIGameCardInventory
                className={styles.progressCardBacksContainer}
                cardState={cardState}
                cardStackSizes={CARD_STACK_SIZES_1}
                cardsToDisable={cardsToDisable}
                cardsToHideBadge={cardsToHideBadge}
                cardSize='xxs'
                enablePartition={false}
                showTipTitle={true}
                forceShowCardBadges={true}
            />
        </div>
    )
}
